import { type Ref, onBeforeUnmount, ref } from 'vue'

import { useIntersectionObserver } from '@vueuse/core'

export function useIsVisible({
  targetElement,
  onIntersection,
}: {
  targetElement: Ref<HTMLElement | null>
  onIntersection: ({ visible }: { visible: boolean }) => void
}) {
  const isVisible = ref(false)
  const { stop } = useIntersectionObserver(targetElement, ([entry]) => {
    isVisible.value = entry.isIntersecting

    onIntersection({ visible: isVisible.value })
  })

  onBeforeUnmount(() => {
    stop()
  })

  return { isVisible }
}
